import React, { Fragment, useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Button, Divider, Dropdown, Grid } from "semantic-ui-react";
import { CreateRequestReviewDocument } from "../../../../../App/models/RequestReviewDocument";
import RequestReviewDocumentQuestions from '../../form/documents/RequestReviewDocumentQuestions'
import LoadingComponent from '../../../../../App/layout/LoadingComponent';

const RequestReviewDocuments: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { createRequestReviewDocument, submitting: submitting, loadingInitialReviewDocuments } = rootStore.requestReviewDocumentStore;
    const { GetFilteredDocumentTypes } = rootStore.requestReviewDocumentQuestionStore;
    const { RequestReview } = rootStore.requestReviewStore;

    const [requestReviewDocument] = useState(new CreateRequestReviewDocument());
    const [disabled, setDisabled] = useState(true);
    const [docTypeSelection, setDocTypeSelection] = useState();

    //TODO:Reactify This and the other places that handleDocTypeChange is required(at least in the Review Forms)
    const handleDocTypeChange = (event: any, data: any) => {
        setDocTypeSelection(data.value);
        setDisabled(false);
    }

    const createNewDocument = async () => {
        // @ts-ignore
        requestReviewDocument.requestReviewId = RequestReview.id;
        // @ts-ignore
        requestReviewDocument.documentType = docTypeSelection;

        await createRequestReviewDocument(requestReviewDocument);
    }

    return (
        <Fragment>
            <LoadingComponent active={loadingInitialReviewDocuments} content='Loading Documents...' />
            {RequestReview?.reviewEnd === null ?


                <Grid columns={2}>
                    <Grid.Column>
                        <Dropdown
                            placeholder='Select a Document Type'
                            fluid
                            search
                            selection
                            options={GetFilteredDocumentTypes()}
                            onChange={handleDocTypeChange}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <Button
                            loading={submitting}
                            content={"Add Document"}
                            labelPosition={'left'}
                            icon={"plus circle"}
                            floated={"right"}
                            className={'rl-btn'}
                            size={'tiny'}
                            disabled={disabled}
                            onClick={createNewDocument}
                        />
                    </Grid.Column>
                </Grid>
                : ""}
            <Divider />
            <div className={'document-content'}>
                <RequestReviewDocumentQuestions />
            </div>
        </Fragment>
    )
}
export default observer(RequestReviewDocuments);